import { RECEIVE_API_METHODS } from '../constants/ActionTypes';

const api = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_API_METHODS:
      return {
        ...state,
        subjects: action.data,
      }
    default:
      return state;
  }
}

export default api;



// WEBPACK FOOTER //
// ./src/reducers/api.js